import {useState, useEffect, useContext} from 'react';
import {
    Container,
    Button,
    Checkbox,
    Grid,
    CircularProgress,
    TextField,
    FormControlLabel,
} from '@mui/material';
import { Alert } from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {UserService, UserRoleService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import Select from 'react-select'
import {CurrentUserContext} from "../../../components/CurrentUserContext";


const UserForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;
    const [roleOptions, setRoleOptions] = useState([]);
    const [roles, setRoles] = useState([]);
    const [data, setData] = useState({});
    const [message, setMessage] = useState('');
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const {refreshUserContext} = useContext(CurrentUserContext);
    const history = useHistory();

    useEffect(() => {

        UserRoleService.getAll().then((response) => {
            setRoleOptions(response.data);
        })

        if (id !== "new") {
            UserService.getById(id).then((response) => {
                setData(response.data);
                setRoles(response.data.userAssignedRoles.map(r => r.userRole.id));
                setIsReady(true);
            });
        } else {
            setData({});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setIsReady(false)
        const userRoles = roleOptions.filter(r => d.roles.includes(r.id));
        if (data.id) {
            UserService.update({...data, ...d, userAssignedRoles: userRoles.map(r => ({userRole: r}))})
                .then((response) => {
                    setMessage('User detail updated.')
                    refreshUserContext();
                    setIsReady(true);
                    history.push("/admin/users");
                });
        } else {
            UserService.create({...data, ...d, userAssignedRoles: userRoles.map(r => ({userRole: r}))})
                .then((response) => {
                    setData(response.data);
                    setMessage('User created.');
                    setIsReady(true);
                    history.push("/admin/users");
                });
        }
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    return (
        <Container>
            <header>
                <h1>User Details</h1>
            </header>
            {
                message && <Alert severity="success">{message}</Alert>
            }
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)}>
                <Grid container>
                    <Grid item xs={12}>
                        <p>
                            Manage user details here.
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="username"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="User Name"
                            color="primary"
                            defaultValue={data.username}
                            rules={{required: 'User name is required.'}}
                            variant="outlined"
                        />
                        <ValidationError error={errors.username}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="email"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Email"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Email is required.'}}
                            defaultValue={data.email}
                        />
                        <ValidationError error={errors.email}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <FormControlLabel label="Enabled" variant="outlined" control={
                            <Controller
                                name="enabled"
                                control={control}
                                color="primary"
                                variant="outlined"
                                defaultValue={data.enabled}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        {/*<FormControlLabel label="Roles" variant="outlined" labelPlacement="top" control={*/}
                        <Controller
                            name="roles"
                            control={control}
                            color="primary"
                            variant="outlined"
                            defaultValue={roles}
                            render={(
                                {onChange, onBlur, value, name, ref},
                                {invalid, isTouched, isDirty}
                            ) => (
                                <Select
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                    options={roleOptions.map(r => ({value: r.id, label: r.roleName}))}
                                    value={roleOptions.map(r => ({
                                        value: r.id,
                                        label: r.roleName
                                    })).filter(c => value.includes(c.value))}
                                    onChange={val => onChange(val.map(c => c.value))}
                                    isMulti
                                    inputRef={ref}
                                />
                            )}
                        />
                        {/*}/>*/}
                    </Grid>
                    <Grid item xs={6}>

                    </Grid>
                    <Grid item>
                        <Button variant="contained" color="primary" type="submit">Submit</Button>
                    </Grid>
                </Grid>

            </form>
        </Container>
    );
};

export default UserForm;
